import { stripStega } from "@datocms/content-link";
import { SiteLocale } from "src/__generated__/graphql";

export const getBlogPath = (locale: SiteLocale, routeName: string) => {
	return `/${locale}/blog/${stripStega(routeName)}/`;
};
